import type { Component } from "solid-js";
import { createSignal } from "solid-js";
import { useTranslation } from "../../../state/i18n";
import { TextAndIconButton } from "../../../components/button/Button";
import ApiService from "../../../services/ApiService";
import { useNavigate } from "@solidjs/router";
import { useCustomerState } from "../../../state/customer";
import type FormId from "../../../state/FormId";
import { useModalManager } from "../../../components/modal/ModalManager";
import GenericFailureModal from "../../GenericFailureModal";

type EditFormButtonProps = {
  formId: FormId;
};

const EditFormButton: Component<EditFormButtonProps> = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { open } = useModalManager();
  const customer = useCustomerState();
  const [isOpeningEditor, setIsOpeningEditor] = createSignal(false);

  return (
    <TextAndIconButton
      text={t(($) => $.EDIT_FORM_BUTTON_LABEL)}
      icon="pencil"
      loading={isOpeningEditor()}
      onClick={() => {
        setIsOpeningEditor(true);
        const formId = props.formId;

        ApiService.resolveFormDraftId(formId)
          .then(async (formVersionId) => {
            navigate(`/customers/${customer.customerId}/forms/${formId}/formVersions/${formVersionId}`);
          })
          .catch((error) => {
            open({ content: () => <GenericFailureModal error={error} /> });
          })
          .finally(() => {
            setIsOpeningEditor(false);
          });
      }}
    />
  );
};

export default EditFormButton;
